import $ from "jquery"
import './../scss/style.scss';
//  import Bootstrap
window.jQuery = window.$ = $;
require('../../node_modules/bootstrap-sass/assets/javascripts/bootstrap');

import Header from "./shared/Header";
import Print from "./shared/Print";
import UMasonry from "./shared/UMasonry";
import AjaxLoader from "./shared/AjaxLoader";
import UFilters from "./calendar/UFilters";
import Contact from "./shared/Contact";
import Catalogue from "./catalogue/Catalogue";
import Horizonav from "./horizonav/Horizonav";
import FontResize from "./shared/FontResize";
import Project from "./project/Project";
import Popup from "./shared/Popup";
import ScreenCarousel from "./screen/ScreenCarousel";
import { initEventTickets } from "./event/event_tickets";
import { initCollapseLabel } from './shared/helpers';
import Showmore from "./shared/Showmore";
import { initFocusVisible } from "./shared/focusVisible";
import { firstFocusUpdate } from "./shared/firstFocus";
import { initBoxesCollapse } from "./shared/boxesCollapse";
import { initCommon } from "./shared/common";
import { initUvoting } from "./shared/uvoting";
import { buildOwl } from "./shared/owlcarousel";
import { initSectionFilter } from "./section/section_filter";
import { initCheckout } from "./ecommerce/checkout";
import { initHomeCarousel } from "./home/home-carousel";

$(() => {
  // do stuff on ready
  initFocusVisible()
  firstFocusUpdate()
  Header.init();
  Print.init();
  UMasonry.init();
  AjaxLoader.init();
  UFilters.init();
  Catalogue.init();
  Horizonav.init();
  FontResize.init();
  Popup.init();
  ScreenCarousel.init();
  initCollapseLabel();
  initEventTickets();
  Showmore.init();
  initBoxesCollapse();
  initCommon()
  initUvoting()
  buildOwl()
  initSectionFilter()
  initCheckout()
  initHomeCarousel();

  let project = new Project();


});

$(window).on( "load", ()=> {
  // do stuff on load
  Contact.init();

});
// init tiny slider carousels
import { initCarousels } from "./shared/carousel"
initCarousels();